import { Injectable } from "@angular/core";
import { Judge, JudgeCategory, JudgeScore } from "../model/judge";
import { ApiService } from "./api";

@Injectable()
export class JudgeService {
    constructor(
        private api: ApiService
    ) { }

    getJudges(rodeoId: number) {
        return this.api.getWithAuth<Judge[]>(`${this.api.endpoints.judges}/GetJudges?rodeoId=${rodeoId}`);
    }

    getJudgeCategories(rodeoId: number) {
        return this.api.getWithAuth<JudgeCategory[]>(`${this.api.endpoints.judges}/GetCategories?rodeoId=${rodeoId}`);
    }

    getScoresForRodeoEvent(rodeoId:number, rodeoEventId: number) : Promise<{judges: Judge[], categories: JudgeCategory[]}> {
        return this.api.getWithAuth<{judges: Judge[], categories: JudgeCategory[]}>(`${this.api.endpoints.judges}/GetScoresByRodeoEvent?rodeoId=${rodeoId}&rodeoEventId=${rodeoEventId}`)
    }

    getScoresForRun(runId: number, rodeoEventId: number) {
        return this.api.getWithAuth<{judges: Judge[], categories: JudgeCategory[]}>(`${this.api.endpoints.judges}/GetScoresByRun?runId=${runId}&rodeoEventId=${rodeoEventId}`)
    }

    setTotalsCalculation(rodeoEventId: number, useAverage: boolean) {
        return this.api.postWithAuth(`${this.api.endpoints.judges}/SetTotalsCalculation?rodeoEventId=${rodeoEventId}&useAverage=${useAverage}`);
    }
    
    saveJudge(judge: Judge) {
        return this.api.postWithAuth<Judge>(`${this.api.endpoints.judges}/SaveJudge`, judge)
    }

    async saveScores(scores: JudgeScore[]) {
        return await this.api.postWithAuth<JudgeScore[]>(`${this.api.endpoints.judges}/SaveScore`, scores);
    }

    async clearScores(runId: number) {
        return await this.api.postWithAuth<JudgeScore[]>(`${this.api.endpoints.judges}/ClearScores?runId=${runId}`);
    }

    saveJudgeCategory(category: JudgeCategory) {
        return this.api.postWithAuth(`${this.api.endpoints.judges}/SaveJudgeCategory`, category); //need to push api for this
    }   

    deleteJudge(id: number) {
        return this.api.deleteWithAuth(`${this.api.endpoints.judges}/DeleteJudge?id=${id}`);
    }

    deleteCategory(id: number) {
        return this.api.deleteWithAuth(`${this.api.endpoints.judges}/DeleteCategory?id=${id}`);
    }
}


// WEBPACK FOOTER //
// ./src/services/judge.service.ts